import glamorous from 'glamorous';

export default glamorous.h3({
  fontSize: '18px',
  textAlign: 'right',
  marginRight: '100px'
});


// WEBPACK FOOTER //
// ./lib/components/content/Attribution.js